// extracted by mini-css-extract-plugin
module.exports = {"Paper":"SelectSeasonFormControl_Paper__2nmjN","Text":"SelectSeasonFormControl_Text__EH1lg","narrow-scrollbar":"SelectSeasonFormControl_narrow-scrollbar__2PN6Q"};